import { create } from "zustand";
import * as couponApi from "../services/couponApi";
import { toast } from "react-hot-toast";



export const useCouponStore = create((set, get) => ({
  coupons: [],
  loading: false,

  filters: {
    searchTerm: "",
    is_active: null,
    expired: null,
  },

  pagination: {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPages: 1,
  },

  modals: {
    formOpen: false,
    excelUploadOpen: false,
    excelPreviewOpen: false,
  },

  selectedCoupon: null,
  excelRows: [],


  setFilters: (filters) =>
    set((state) => ({
      filters: { ...state.filters, ...filters },
      pagination: { ...state.pagination, page: 1 },
    })),

  setPage: (page) =>
    set((state) => ({
      pagination: { ...state.pagination, page },
    })),

  openForm: (coupon = null) =>
    set({
      selectedCoupon: coupon,
      modals: { ...get().modals, formOpen: true },
    }),

  closeForm: () =>
    set({
      selectedCoupon: null,
      modals: { ...get().modals, formOpen: false },
    }),

fetchCoupons: async (pageParam = null) => {
    const { filters, pagination } = get();
    const page = pageParam ?? pagination.page;

    set({ loading: true });

    try {
        const res = await couponApi.getCoupons({
            ...filters,
            page,
        });

        // بررسی ساختار داده برای جلوگیری از خطای Invalid Array Length
        const count = res.data?.count ?? 0;
        const results = res.data?.results ?? [];
        const pageSize = pagination.pageSize;
        const totalPages = Math.ceil(count / pageSize);

        set({
            coupons: results,
            pagination: {
                ...pagination,
                page,
                total: count,
                totalPages: totalPages > 0 ? totalPages : 1, // حداقل یک صفحه داشته باشیم
            },
        });

    } catch (error) {
        console.error("Error fetching coupons:", error);

        // نمایش پیام خطا به کاربر
        const errorMessage = error.response?.data?.message || "خطا در دریافت اطلاعات کوپن‌ها";
        toast.error(errorMessage);

        // در صورت خطا، لیست را خالی می‌کنیم یا به حالت قبل نگه می‌داریم
        set({ coupons: [] });

    } finally {
        // این بلوک چه درخواست موفق باشد چه با خطا، اجرا می‌شود
        set({ loading: false });
    }
},

  createCoupon: async (data) => {
    await couponApi.createCoupon(data);
    await get().fetchCoupons(1);
  },

  updateCoupon: async (id, data) => {
    await couponApi.updateCoupon(id, data);
    await get().fetchCoupons();
  },

  uploadExcel: (rows) => {

  const mapped = rows.map((row) => ({
    id: row["کد یکتا"] ?? null,
    title: row["عنوان"],
    code: row["کد"],
    discount_type: row["نوع تخفیف"],

    discount_value: row["مقدار تخفیف"] ?? 0,
    usage_limit: row["حداکثر تعداد استفاده"] ?? 1,
    usage_count: row["تعداد استفاده"] ?? 0,
    min_order_amount: row["حداقل سفارش"] ?? 0,
    max_discount_amount: row["حداکثر تخفیف"] ?? 0,

    expiration_date: row["تاریخ انقضا"],

    phone_number: String(row["شماره موبایل"]).padStart(11, "0"),
    username: row["نام و نام خانوادگی"],

    is_active:
      row["وضعیت فعال بودن"] === "فعال" ||
      row["وضعیت فعال بودن"] === "true" ||
      row["وضعیت فعال بودن"] === true ||
      row["وضعیت فعال بودن"] === 1,
  }))

  set({
    excelRows: mapped,
    modals: { ...get().modals, excelPreviewOpen: true }
  })
},


bulkUpload: async () => {

  const rows = get().excelRows

  const res = await couponApi.bulkUploadCoupons({
  rows
})

  toast.success("کوپن ها ثبت شدند")

  set({
    modals: { ...get().modals, excelPreviewOpen: false },
    excelRows: []
  })

  get().fetchCoupons()
},

closeExcelPreview: () =>
    set({
      modals: { ...get().modals, excelPreviewOpen: false },
    }),

}));

